import React from 'react';
import { Box } from '@mui/material';

const Logo: React.FC = () => (
  <Box className="logo">
    <img src='asset/image/logo.svg' alt="logo" />
  </Box>
);

export default Logo;